import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import WatchTagCreateEditForm from './Components/WatchTagCreateEditForm';
import WatchTagApi from './WatchTagApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: WatchTagCreateEditForm,
                getCreate: WatchTagApi.create,
                getClone: WatchTagApi.getOne,
                defaults: {},
                successMessage: "WatchTag Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}